import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewScore', {
  BEST: 5,
  GOOD: 4,
  NORMAL: 3,
  BAD: 2,
  WORST: 1
});
